interface SummerData {
    image: string,
    text: string,
    city: string,
    name: string,
}

export const summerData: SummerData[] = [
    {
        image: "/images/labadee1.jpg",
        text: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
        city: "Okap",
        name: "Labadee",
    },
    {
        image: "/images/geleebeach1.jpg",
        text: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
        city: "Monwi",
        name: "Gelee Beach",
    },
    {
        image: "/images/fortoge1.jpg",
        text: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
        city: "Kap wouj                                                   ",
        name: "Fort Oge",
    },
    {
        image: "/images/Bassin-Bleu..jpg",
        text: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
        city: "Jakmèl",
        name: "Bassin Bleu",
    },
];